import { GetTechnicalsConfigResponse, TechnicalsIndicatorSpec } from '../../../proto/generated/overview-widget'
import { TechnicalsRowResult } from '../../../util/technicals'
import { computeIndicator } from './computeIndicators'
import { computeTechnicalsPivots } from './technicalsPivots'
import { computeUptrend, rateIndicator } from './technicalsRating'
import { TechnicalsCandleSeries, TechnicalsComputedResult } from './types'

const buildRow = (
    spec: TechnicalsIndicatorSpec,
    series: TechnicalsCandleSeries,
    uptrend: boolean | null,
    thresholds: Record<string, number>
): TechnicalsRowResult => {
    const computed = computeIndicator(spec, series)
    if (!computed || computed.value === undefined || Number.isNaN(computed.value)) {
        return { id: spec.id, name: spec.name, value: undefined, action: 'Neutral' }
    }

    const action = rateIndicator(
        spec.ratingStyle,
        {
            value: computed.value,
            previous: computed.previous,
            previousPrevious: computed.previousPrevious,
            extras: computed.extras,
            uptrend: spec.needsTrend ? uptrend : undefined
        },
        series.lastClose,
        thresholds
    )

    return {
        id: spec.id,
        name: spec.name,
        value: computed.value,
        action
    }
}

export const computeTechnicals = (
    config: GetTechnicalsConfigResponse,
    series: TechnicalsCandleSeries,
    timeframeId: string
): TechnicalsComputedResult => {
    const thresholds = config.thresholds ?? {}
    const trendLen = thresholds['trend.sma_length'] ?? 50
    const uptrend = computeUptrend(series.close, trendLen)

    const oscillators = (config.oscillators ?? []).map((spec) => buildRow(spec, series, uptrend, thresholds))
    const movingAverages = (config.movingAverages ?? []).map((spec) => buildRow(spec, series, uptrend, thresholds))
    const pivots = computeTechnicalsPivots(series)

    return {
        oscillators,
        movingAverages,
        pivots,
        lastClose: Number.isNaN(series.lastClose) ? undefined : series.lastClose,
        detailTimeframe: timeframeId
    }
}
